import { RouteProps } from '../../routes/AppRouter'
import { Configuration as C } from '../../features/configuration'
import React from 'react'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function Configuration(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <C />
    </>
  )
}
